/**
 * Module dependencies.
 */

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogTrigger
} from 'app/components/ui/alert-dialog';
import { Button } from 'app/components/atoms/button/button';
import { Loader2, Trash2 } from 'lucide-react';
import { Transaction } from 'app/hooks/requests/apps-crypto/use-get-apps-crypto-overview';
import { useDeleteTransaction } from 'app/hooks/requests/apps-crypto/use-delete-transaction';
import { useTranslation } from 'react-i18next';
import React from 'react';

/**
 * `Props` type.
 */

type Props = {
  item: Transaction;
  setPause: (value: boolean) => void;
  refetch: () => any;
};

/**
 * Export `RemoveAction` component.
 */

export function RemoveAction({ item, setPause, refetch }: Props): JSX.Element {
  const [translate] = useTranslation();
  const { mutate: deleteAction, isLoading } = useDeleteTransaction();

  return (
    <AlertDialog
      onOpenChange={open => {
        setPause(open);

        if (!open) {
          refetch();
        }
      }}
    >
      <AlertDialogTrigger asChild onClick={(event: any) => event.stopPropagation()}>
        <Button danger icon={<Trash2 className={'h-4 w-4'} />} size={'small'} />
      </AlertDialogTrigger>

      <AlertDialogContent onClick={(event: any) => event.stopPropagation()}>
        <AlertDialogTitle>{translate('removeAction')}</AlertDialogTitle>

        <AlertDialogFooter>
          <AlertDialogCancel>{'Cancel'}</AlertDialogCancel>

          <AlertDialogAction
            className={'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90'}
            disabled={isLoading}
            onClick={(event: any) => {
              event.stopPropagation();
              deleteAction(item.id);
            }}
          >
            {isLoading && <Loader2 className={'mr-2 h-4 w-4 animate-spin'} />}

            {'OK'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
